module.exports = __webpack_public_path__ + "img/connection-video.60f9f74a.jpg";